import classNames from 'classnames';
import { h, JSX } from 'preact';

export interface PosterProps {
    class?: string;
    url?: string;
}

export const Poster = (props: PosterProps): JSX.Element => (
    <div>
        {props.url && (
            <div class={classNames('relative', props.class)}>
                <div class='hidden sm:block w-24 mr-6 lg:w-44 lg:mr-12 shrink-0'>
                    <img class='block w-full rounded-lg' src={props.url} />
                </div>
            </div>
        )}
    </div>
);
